import React from 'react';
import { MdArrowBack, MdPhoneInTalk, MdEventAvailable, MdLocationOn, MdChevronRight, MdPeople } from 'react-icons/md';
import { useApp } from '../contexts/AppContext';

// Public TD Direct Investing line + public advisor booking URL — no proprietary data.
const ADVISOR_PHONE = '1-866-233-3234';
const BOOK_URL = 'https://www.td.com/ca/en/personal-banking/book-appointment#/appointment-type';

const AdvisorScreen = ({ onNavigate, onBack }) => {
  const { theme } = useApp() || {};
  const isLight = theme !== 'purple';

  // Style tokens — mirror TransactionDetailScreen so themes stay consistent.
  const bg       = isLight ? '#f4f6f8' : 'var(--bg-screen)';
  const cardBg   = isLight ? '#fff' : 'rgba(255,255,255,0.05)';
  const cardBdr  = isLight ? 'rgba(0,0,0,0.07)' : 'rgba(255,255,255,0.08)';
  const heroText = isLight ? '#111' : 'rgba(220,235,255,0.95)';
  const subText  = isLight ? '#666' : 'rgba(160,210,255,0.6)';
  const valClr   = isLight ? '#111' : 'rgba(220,235,255,0.9)';
  const labelClr = isLight ? '#888' : 'rgba(160,210,255,0.5)';
  const teal     = '#448889';

  const OptionCard = ({ Icon, title, sub, href, target, onClick }) => {
    const inner = (
      <>
        <div style={{ width: 40, height: 40, borderRadius: 10, background: teal, display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 }}>
          <Icon size={22} color="#fff" />
        </div>
        <div style={{ flex: 1, minWidth: 0 }}>
          <div style={{ fontSize: 15, fontWeight: 600, color: valClr }}>{title}</div>
          <div style={{ fontSize: 13, color: subText, marginTop: 2 }}>{sub}</div>
        </div>
        <MdChevronRight size={22} style={{ color: labelClr, flexShrink: 0 }} />
      </>
    );
    const style = {
      display: 'flex', alignItems: 'center', gap: 12, width: '100%', textAlign: 'left',
      background: cardBg, border: `1px solid ${cardBdr}`, borderRadius: 14,
      padding: '14px 16px', margin: '0 16px 12px', cursor: 'pointer', boxSizing: 'border-box',
      color: 'inherit', textDecoration: 'none',
    };
    if (href) {
      return (
        <a href={href} target={target} rel={target === '_blank' ? 'noopener noreferrer' : undefined} style={style}>
          {inner}
        </a>
      );
    }
    return (
      <button type="button" onClick={onClick} style={style}>
        {inner}
      </button>
    );
  };

  return (
    <div className="screen bh-flow" style={{ background: bg }}>
      {/* Header */}
      <header className="bh-flow-hero">
        <div className="bh-flow-hero-left">
          <button className="bh-flow-back" onClick={onBack} aria-label="Back"><MdArrowBack /></button>
          <h1 className="bh-flow-title">Speak with a TD advisor</h1>
        </div>
      </header>

      <div className="bh-flow-body">

        {/* Positioning line — padding-top must match bh-flow-body's -space-md overlap */}
        <div style={{ padding: 'var(--space-md) 20px 8px' }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: 8, marginBottom: 8 }}>
            <MdPeople size={22} color={teal} />
            <span style={{ fontSize: 13, fontWeight: 700, color: teal, textTransform: 'uppercase', letterSpacing: '0.05em' }}>
              Talk to a person
            </span>
          </div>
          <div style={{ fontSize: 14, color: subText, lineHeight: 1.55 }}>
            For questions that go beyond what IVA can help with — estate planning,
            complex tax situations, and more.
          </div>
        </div>

        {/* Contact options */}
        <div style={{ marginTop: 8 }}>
          <OptionCard
            Icon={MdPhoneInTalk}
            title="Call us"
            sub={ADVISOR_PHONE}
            href={`tel:${ADVISOR_PHONE.replace(/[^0-9]/g, '')}`}
          />
          <OptionCard
            Icon={MdEventAvailable}
            title="Book an appointment"
            sub="Schedule online"
            href={BOOK_URL}
            target="_blank"
          />
          <OptionCard
            Icon={MdLocationOn}
            title="Visit a branch"
            sub="Find a location near you"
            onClick={() => onNavigate('locations')}
          />
        </div>

        {/* What to bring */}
        <div style={{ background: cardBg, border: `1px solid ${cardBdr}`, borderRadius: 14, margin: '8px 16px 12px', padding: '16px 18px' }}>
          <div style={{ fontSize: 11, fontWeight: 700, color: labelClr, textTransform: 'uppercase', letterSpacing: '0.06em', marginBottom: 10 }}>
            What to bring
          </div>
          <ul style={{ margin: 0, paddingLeft: 18, color: valClr, fontSize: 14, lineHeight: 1.7 }}>
            <li>your goals and timeline</li>
            <li>a list of accounts inside and outside TD</li>
            <li>any tax documents you have</li>
          </ul>
        </div>

        {/* Footer disclaimer */}
        <div style={{ padding: '4px 24px 32px', textAlign: 'center' }}>
          <div style={{ fontSize: 12, color: subText, lineHeight: 1.5 }}>
            All advice from a licensed advisor is separate from IVA.
          </div>
        </div>

      </div>
    </div>
  );
};

export default AdvisorScreen;
